export const moonbeamZaps = [
  {
    // Stellaswap
    zapAddress: '0x24Ef232A309fd4531343DDb69C49ae395A320c8B',
    ammRouter: '0xd0A01ec574D1fC6652eDF79cb2F880fd47D34Ab1',
    ammFactory: '0x68a384d826d3678f78bb9fb1533c7e9577dacc0e',
    ammPairInitHash: '0x48a6ca3d52d0d0a6c53a83cc3c8688dd46ea4cb786b169ee959b95ad30f61643',
  },
  {
    // Beamswap
    zapAddress: '0xdf68Bf80D427A5827Ff2c06A9c70D407e17DC041',
    ammRouter: '0x96b244391D98B62D19aE89b1A4dCcf0fc56970C7',
    ammFactory: '0x985BcA32293A7A496300a48081947321177a86FD',
    ammPairInitHash: '0xe31da4209ffcce713230a74b5287fa8ec84797c9e77e1f7cfeccea015cdc97ea',
  },
];
